module.exports = __webpack_public_path__ + "img/1f379.c948bdd.svg";